import { render, staticRenderFns } from "./CustomBlock.vue?vue&type=template&id=21d8a6d4&"
import script from "./CustomBlock.vue?vue&type=script&lang=js&"
export * from "./CustomBlock.vue?vue&type=script&lang=js&"
import style0 from "./CustomBlock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports